import { Numeric3BoxMultipleOutlineIcon } from './Numeric3BoxMultipleOutlineIcon';

/**
 * author: Google
 * id 394B1DFD-7009-4057-AD14-7F7D99B3A658
 * name numeric-3-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-3-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number3BoxMultipleOutlineIcon = Numeric3BoxMultipleOutlineIcon;
export default Number3BoxMultipleOutlineIcon